/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Toast_Approve_PxkInputs */

const vi_aml_toast_approve_pxk = /** @type {(inputs: Aml_Toast_Approve_PxkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt phiếu xuất kho`)
};

/**

* @param {Aml_Toast_Approve_PxkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_toast_approve_pxk = /** @type {((inputs?: Aml_Toast_Approve_PxkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Toast_Approve_PxkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_toast_approve_pxk(inputs)
});